import { render, staticRenderFns } from "./CulturalScore.vue?vue&type=template&id=64a0c150"
import script from "./CulturalScore.vue?vue&type=script&lang=js"
export * from "./CulturalScore.vue?vue&type=script&lang=js"
import style0 from "./CulturalScore.vue?vue&type=style&index=0&id=64a0c150&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports